import DutchFlag from '../assets/dutchFlag.svg';
import BelgianFlag from '../assets/belgianFlag.svg';
import GermanFlag from '../assets/germanFlag.svg';
import LuxembourgFlag from '../assets/luxembourgFlag.svg';
import AustrianFlag from '../assets/austrianFlag.svg';
import BulgarianFlag from '../assets/bulgarianFlag.svg';
import RomanianFlag from '../assets/romanianFlag.svg';
import DanishFlag from '../assets/danishFlag.svg';
import PolishFlag from '../assets/polishFlag.svg';
import FrenchFlag from '../assets/frenchFlag.svg';
import CzechFlag from '../assets/czechFlag.svg';
import UnitedKingdomFlag from '../assets/unitedKingdomFlag.svg';
import { CountryCode } from 'libphonenumber-js';

export interface Country {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  code: string;
  country: CountryCode;
  isB2b?: boolean;
  label?: string;
}

export const countryCodes: Country[] = [
  { icon: DutchFlag, code: '+31', country: 'NL', isB2b: false, label: 'Dutch' },
  { icon: BelgianFlag, code: '+32', country: 'BE', isB2b: false },
  { icon: GermanFlag, code: '+49', country: 'DE', isB2b: false, label: 'German' },
  { icon: UnitedKingdomFlag, code: '+44', country: 'GB', isB2b: true, label: 'English' },
  { icon: FrenchFlag, code: '+33', country: 'FR', isB2b: true, label: 'French' },
  { icon: LuxembourgFlag, code: '+352', country: 'LU', isB2b: true },
  { icon: CzechFlag, code: '+420', country: 'CZ', isB2b: true },
  { icon: DanishFlag, code: '+45', country: 'DK', isB2b: true },
  { icon: AustrianFlag, code: '+43', country: 'AT', isB2b: true },
  { icon: PolishFlag, code: '+48', country: 'PL', isB2b: true },
  { icon: BulgarianFlag, code: '+359', country: 'BG', isB2b: true },
  { icon: RomanianFlag, code: '+40', country: 'RO', isB2b: true }
];
